import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { firestoreQuery } from '../firebase';
import { AppThunk } from '../store';
import { Trait, TraitValue } from '../types/nft';

interface TraitValueMap {
  [ trait: string ]: {
    [ value: string ]: TraitValue
  }
}

interface TraitMap { [ id: string ]: Trait };

interface TraitsState {
  traits: TraitMap,
  values: TraitValueMap;
  loading: boolean;
  loaded: boolean;
}

const initialState: TraitsState = {
  traits: {},
  values: {},
  loading: false,
  loaded: false,
}


const service = createSlice({
  name: 'traits',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>): TraitsState {
      return { ...state, loading: action.payload, }
    },
    setLoaded(state): TraitsState {
      return { ...state, loaded: true, }
    },
    setTraits(state, action: PayloadAction<TraitMap>): TraitsState {
      return { ...state, traits: { ...action.payload }, }
    },
    setValues(state, action: PayloadAction<TraitValueMap>): TraitsState {
      return { ...state, values: { ...action.payload }, }
    },
  }
});



const load = (): AppThunk => async (dispatch, getState) => {
  try {
    dispatch(service.actions.setLoading(true));
    const traits = await firestoreQuery<Trait>('traits');
    const map: TraitMap = {};
    const valueMap: TraitValueMap = {};

    for (const trait of traits.list) {
      map[ trait.name ] = trait;
      valueMap[trait.name] = {};
      for (const value of trait.values) {
        valueMap[trait.name][value.name] = value;
      }
    }

    dispatch(service.actions.setTraits(map));
    dispatch(service.actions.setValues(valueMap));
  }
  catch (e) {
    console.error(e);
  }
  finally {
    dispatch(service.actions.setLoading(false));
    dispatch(service.actions.setLoaded());
  }
}


export const actions = {
  load,
}

export default service.reducer;